import { Period } from "@overbookd/time";
import { CONFIANCE, HARD, VIEUX } from "@overbookd/team-code";
//#region src/volunteer.ts
var FormatVolunteer = class {
	constructor() {}
	static computeAssignmentDuration(assignments) {
		return assignments.reduce((acc, assignment) => acc + assignment.duration.inMilliseconds, 0);
	}
};
//#endregion
//#region src/assign-volunteer-to-task/assign-volunteer-to-task.ts
var AssignVolunteerToTask = class {
	allVolunteers;
	constructor(allVolunteers) {
		this.allVolunteers = allVolunteers;
	}
	async volunteers() {
		return (await this.allVolunteers.findAll()).map((assignee) => this.computeAssignmentDuration(assignee));
	}
	computeAssignmentDuration({ assignments, ...volunteer }) {
		const assignmentDuration = FormatVolunteer.computeAssignmentDuration(assignments);
		return {
			...volunteer,
			assignmentDuration
		};
	}
};
//#endregion
//#region src/assign-task-to-volunteer/assignment.ts
function isTeamMember(assignee) {
	return Object.hasOwn(assignee, "as");
}
function isMemberOf(team) {
	return (assignee) => {
		if (!isTeamMember(assignee)) return false;
		return assignee.as === team;
	};
}
function isWithDetails(assignment) {
	return Object.hasOwn(assignment, "appointment");
}
//#endregion
//#region src/count-assignees-in-team.ts
function countAssigneesInTeam(team, assignees) {
	return assignees.filter(isMemberOf(team)).length;
}
//#endregion
//#region src/assign-task-to-volunteer/assign-task-to-volunteer.ts
var AssignTaskToVolunteer = class {
	allTasks;
	assignableVolunteers;
	constructor(allTasks, assignableVolunteers) {
		this.allTasks = allTasks;
		this.assignableVolunteers = assignableVolunteers;
	}
	async assignableTasks() {
		return (await this.allTasks.findAll()).map((task) => this.computeMissingAssignmentTeams(task)).filter((task) => task.teams.length > 0);
	}
	async allTasksForAssignment() {
		return (await this.allTasks.findAll()).map((task) => this.computeAssignmentTeams(task));
	}
	async selectTask(taskId) {
		const task = await this.allTasks.findOne(taskId);
		return this.computeAssignmentsSummary(task);
	}
	async selectAssignment(assignmentIdentifier) {
		const task = await this.allTasks.findOne(assignmentIdentifier.taskId);
		const assignment = task.assignments.find(({ assignmentId, mobilizationId }) => assignmentId === assignmentIdentifier.assignmentId && mobilizationId === assignmentIdentifier.mobilizationId);
		if (!assignment) throw new Error("Assignment not found");
		const assignmentSpecification = {
			period: Period.init(assignment),
			oneOfTheTeams: this.filterMissingTeamMembers(assignment)
		};
		return (await this.assignableVolunteers.on(assignmentIdentifier, assignmentSpecification)).map(({ assignments, requestedDuring, ...volunteer }) => {
			const totalAssignmentDuration = FormatVolunteer.computeAssignmentDuration(assignments.map((period) => Period.init(period)));
			const assignmentDuration = FormatVolunteer.computeAssignmentDuration(assignments.filter(({ category }) => category === task.category).map((period) => Period.init(period)));
			const isRequestedOnSamePeriod = requestedDuring.some((period) => period.isOverlapping(Period.init(assignment)));
			return {
				...volunteer,
				totalAssignmentDuration,
				assignmentDuration,
				isRequestedOnSamePeriod
			};
		});
	}
	computeMissingAssignmentTeams(task) {
		const missingTeamMembers = task.assignments.reduce((teams, assignment) => {
			const missingMembers = this.filterMissingTeamMembers(assignment);
			return /* @__PURE__ */ new Set([...teams, ...missingMembers]);
		}, /* @__PURE__ */ new Set());
		const lastAssignmentEnd = task.assignments.map(({ end }) => end).reduce((a, b) => a > b ? a : b);
		return {
			id: task.id,
			name: task.name,
			topPriority: task.topPriority,
			category: task.category,
			inChargeTeam: task.inChargeTeam,
			teams: Array.from(missingTeamMembers),
			lastAssignmentEnd
		};
	}
	filterMissingTeamMembers({ demands, assignees }) {
		return demands.filter(({ team, demand: demands }) => {
			return countAssigneesInTeam(team, assignees) < demands;
		}).map(({ team }) => team);
	}
	computeAssignmentTeams(task) {
		const teams = new Set(task.assignments.flatMap((assignment) => assignment.demands.map(({ team }) => team)));
		const lastAssignmentEnd = task.assignments.map(({ end }) => end).reduce((a, b) => a > b ? a : b);
		return {
			id: task.id,
			name: task.name,
			topPriority: task.topPriority,
			category: task.category,
			inChargeTeam: task.inChargeTeam,
			teams: Array.from(teams),
			lastAssignmentEnd
		};
	}
	computeAssignmentsSummary(task) {
		const assignments = task.assignments.map((assignment) => {
			const period = Period.init(assignment);
			const { taskId, mobilizationId, assignmentId } = assignment;
			return {
				start: period.start,
				end: period.end,
				taskId,
				mobilizationId,
				assignmentId,
				teams: assignment.demands.map(({ team, demand }) => ({
					team,
					demand,
					assigned: countAssigneesInTeam(team, assignment.assignees)
				}))
			};
		});
		return {
			id: task.id,
			name: task.name,
			category: task.category,
			assignments
		};
	}
};
//#endregion
//#region src/assignment.error.ts
var AssignmentError = class extends Error {};
var TaskNotFoundError = class extends AssignmentError {
	constructor(taskId) {
		super(`La FT #${taskId} est introuvable`);
	}
};
var WrongTeam = class extends AssignmentError {
	constructor(volunteerId, teamCode) {
		super(`La bénévole #${volunteerId} ne peut pas être affecté en tant que ${teamCode}`);
	}
};
//#endregion
//#region src/candidate-teams.ts
function retrieveImplicitTeams(teams) {
	const areConfianceByDefault = [HARD, VIEUX];
	return teams.some((team) => areConfianceByDefault.includes(team)) ? [...teams, CONFIANCE] : teams;
}
function extendOneOfTeams(oneOfTeams) {
	return oneOfTeams.includes(CONFIANCE) ? [
		...oneOfTeams,
		VIEUX,
		HARD
	] : oneOfTeams;
}
//#endregion
//#region src/assign-task-to-volunteer/funnel/candidate.ts
var Candidate = class Candidate {
	candidate;
	constructor(candidate) {
		this.candidate = candidate;
	}
	static init({ volunteer, friends }, { planning, availabilities, breakPeriods }, assignment) {
		const assignableTeams = Candidate.getAssignableTeams(assignment, volunteer.teams);
		const as = assignableTeams.length === 1 ? assignableTeams.at(0) : void 0;
		return new Candidate({
			...volunteer,
			friends,
			planning,
			availabilities,
			as,
			assignableTeams,
			breakPeriods
		});
	}
	static from(candidate) {
		return new Candidate(candidate);
	}
	static getAssignableTeams({ demands, assignees }, teams) {
		return assignableTeamsAccordingToRemainingDemands(teams, demands.reduce((remainingDemands, { team, demand }) => {
			const totalAssignees = assignees.filter(isMemberOf(team)).length;
			if (totalAssignees === demand) return remainingDemands;
			return [...remainingDemands, {
				team,
				demand: demand - totalAssignees
			}];
		}, []));
	}
	static toAssignment({ id, as }) {
		return {
			id,
			as
		};
	}
	demandAs(as) {
		if (!this.candidate.assignableTeams.includes(as)) throw new Error(`${this.name} is not team member of ${as}`);
		return new Candidate({
			...this.candidate,
			as
		});
	}
	assignableTeamsAccordingTo(remainingDemands) {
		const { teams } = this.candidate;
		return assignableTeamsAccordingToRemainingDemands(teams, remainingDemands);
	}
	get name() {
		return `${this.candidate.firstName} ${this.candidate.lastName}`;
	}
	get json() {
		return this.candidate;
	}
};
function assignableTeamsAccordingToRemainingDemands(teams, remainingDemands) {
	return retrieveImplicitTeams(teams).filter((team) => remainingDemands.map(({ team }) => team).includes(team));
}
function isFulfillingDemand(candidate) {
	return candidate.as !== void 0;
}
var CandidateFactory = class {
	agendas;
	friends;
	constructor(agendas, friends) {
		this.agendas = agendas;
		this.friends = friends;
	}
	async from(volunteer, assignment) {
		const { start, end } = assignment;
		const [planning, availabilities, breakPeriods, friends] = await Promise.all([
			this.agendas.planning.for(volunteer.id),
			this.agendas.availabilities.for(volunteer.id),
			this.agendas.breakPeriods.for(volunteer.id),
			this.friends.availableDuringWith({
				start,
				end
			}, volunteer.id)
		]);
		const agenda = {
			planning,
			availabilities,
			breakPeriods
		};
		const relationShip = {
			volunteer,
			friends
		};
		return Candidate.init(relationShip, agenda, assignment);
	}
};
//#endregion
//#region src/assign-task-to-volunteer/funnel/funnel.ts
var FunnelError = class extends Error {};
//#endregion
//#region src/assign-task-to-volunteer/funnel/startup-funnel.ts
var InactiveFunnel = class {
	candidates = [];
	canAssign = false;
	assign() {
		return Promise.reject(new FunnelError("Impossible d'affecter pour le moment"));
	}
	canFulfillMoreRemainingDemands = false;
	addCandidate() {
		return Promise.resolve(this);
	}
	fulfillDemand() {
		return this;
	}
	canRevokeLastCandidate = false;
	revokeLastCandidate() {
		return this;
	}
	canChangeLastCandidate = false;
	previousCandidate() {
		return Promise.resolve(this);
	}
	nextCandidate() {
		return Promise.resolve(this);
	}
};
var ReadyToStart = class ReadyToStart extends InactiveFunnel {
	candidateFactory;
	assignments;
	constructor(candidateFactory, assignments) {
		super();
		this.candidateFactory = candidateFactory;
		this.assignments = assignments;
	}
	static init(candidateFactory, assignments) {
		return new ReadyToStart(candidateFactory, assignments);
	}
	select(assignment) {
		return WaitingForVolunteer.init(this.candidateFactory, this.assignments, assignment);
	}
};
var WaitingForVolunteer = class WaitingForVolunteer extends InactiveFunnel {
	candidateFactory;
	assignments;
	assignment;
	constructor(candidateFactory, assignments, assignment) {
		super();
		this.candidateFactory = candidateFactory;
		this.assignments = assignments;
		this.assignment = assignment;
	}
	static init(candidateFactory, assignments, assignment) {
		return new WaitingForVolunteer(candidateFactory, assignments, assignment);
	}
	async select(volunteer) {
		const candidate = await this.candidateFactory.from(volunteer, this.assignment);
		const repositories = {
			assignments: this.assignments,
			candidateFactory: this.candidateFactory
		};
		return AssignVolunteerFunnel.init([
			[candidate],
			repositories,
			this.assignment
		]);
	}
};
//#endregion
//#region src/assign-task-to-volunteer/funnel/funnel-shared-logic.ts
var CommonFunnel = class {
	_candidates;
	repositories;
	assignment;
	constructor(_candidates, repositories, assignment) {
		this._candidates = _candidates;
		this.repositories = repositories;
		this.assignment = assignment;
	}
	get candidates() {
		return this._candidates.map(({ json }) => json);
	}
	get canAssign() {
		return areEveryCandidateFulfillingDemand(this._candidates);
	}
	get canFulfillMoreRemainingDemands() {
		const candidates = this._candidates;
		if (this.canTheyFulfillAllDemands(candidates)) return false;
		return this.hasAssignableFriends(candidates);
	}
	canTheyFulfillAllDemands(candidates) {
		const remainingDemands = this.remainingDemandsIfAssignThose(candidates);
		const candidatesWithoutSelectedTeam = candidates.filter((candidate) => !isFulfillingDemand(candidate.json));
		const totalRemainingDemands = remainingDemands.reduce((total, { demand }) => total + demand, 0);
		return candidatesWithoutSelectedTeam.length === totalRemainingDemands;
	}
	remainingDemandsIfAssignThose(candidates) {
		return this.assignment.demands.reduce((remainingDemands, { team, demand }) => {
			const temporarlyAssigned = candidates.filter((candidate) => isMemberOf(team)(candidate.json)).length;
			if (temporarlyAssigned === demand) return remainingDemands;
			return [...remainingDemands, {
				team,
				demand: demand - temporarlyAssigned
			}];
		}, []);
	}
	get friendsAbleToFulfillNextDemand() {
		const allAssignableFriends = this.assignableFriendsFrom(this._candidates);
		if (this._candidates.length === 1) return allAssignableFriends;
		const lastCandidate = this._candidates.at(-1);
		if (lastCandidate === void 0) return allAssignableFriends;
		const candidateIndex = this.friendsAssignableOnLastDemand.findIndex((friend) => friend.id === lastCandidate.json.id);
		const notSeenCandidates = allAssignableFriends.slice(candidateIndex);
		const skippedCandidates = allAssignableFriends.slice(0, candidateIndex);
		return [...notSeenCandidates, ...skippedCandidates];
	}
	get friendsAssignableOnLastDemand() {
		return this.assignableFriendsFrom(this.otherCandidatesThanTheLastOne);
	}
	hasAssignableFriends(candidates) {
		return this.assignableFriendsFrom(candidates).length > 0;
	}
	assignableFriendsFrom(candidates) {
		const remainingDemands = this.remainingDemandsIfAssignThose(candidates);
		const assignment = {
			...this.assignment,
			demands: remainingDemands
		};
		return candidates.flatMap((candidate) => candidate.json.friends).reduce((friends, friend) => {
			const isNotACandidateYet = candidates.every(({ json }) => json.id !== friend.id);
			const isAssignable = isAssignableOn(assignment, friend);
			const isNotAlreadyListed = friends.every(({ id }) => id !== friend.id);
			if (!(isNotACandidateYet && isAssignable && isNotAlreadyListed)) return friends;
			return [...friends, friend];
		}, []);
	}
	get canRevokeLastCandidate() {
		return this._candidates.length > 1;
	}
	get otherCandidatesThanTheLastOne() {
		return this._candidates.slice(0, -1);
	}
	get canChangeLastCandidate() {
		return this.assignableFriendsFrom(this.otherCandidatesThanTheLastOne).length > 1;
	}
};
function isAssignableOn(assignment, volunteer) {
	return Candidate.getAssignableTeams(assignment, volunteer.teams).length > 0;
}
function areEveryCandidateFulfillingDemand(candidates) {
	return candidates.every((candidate) => isFulfillingDemand(candidate.json));
}
//#endregion
//#region src/assign-task-to-volunteer/funnel/assign-volunteer-funnel.ts
var AssignVolunteerFunnel = class AssignVolunteerFunnel extends CommonFunnel {
	static init(initializer) {
		const [candidates, repositories, assignment] = initializer;
		return new AssignVolunteerFunnel(candidates, repositories, assignment);
	}
	async assign() {
		if (!areEveryCandidateFulfillingDemand(this._candidates)) return Promise.reject(new FunnelError("Les candidat·e·s ne sont pas toustes affecté·e·s a une équipe"));
		const { taskId, mobilizationId, assignmentId } = this.assignment;
		const assignment = {
			taskId,
			mobilizationId,
			assignmentId
		};
		const volunteers = this._candidates.map(({ json }) => Candidate.toAssignment(json));
		await this.repositories.assignments.assign({
			assignment,
			volunteers
		});
		const { candidateFactory, assignments } = this.repositories;
		return ReadyToStart.init(candidateFactory, assignments);
	}
	async addCandidate() {
		if (!this.canFulfillMoreRemainingDemands) return Promise.resolve(this);
		const [nextFriend] = this.friendsAbleToFulfillNextDemand;
		const asCandidate = await this.toCandidate(nextFriend);
		const candidates = [...this._candidates, asCandidate];
		const assignedCandidates = this.assignCandidateAccordingToRemainingDemands(candidates);
		return new AssignVolunteerFunnel(assignedCandidates, this.repositories, this.assignment);
	}
	assignCandidateAccordingToRemainingDemands(candidates) {
		const remainingDemands = this.remainingDemandsIfAssignThose(candidates);
		return candidates.map((candidate) => {
			if (isFulfillingDemand(candidate.json)) return candidate;
			const remainingAssignableTeams = candidate.assignableTeamsAccordingTo(remainingDemands);
			if (remainingAssignableTeams.length > 1) return candidate;
			const [lastRemainingTeam] = remainingAssignableTeams;
			return candidate.demandAs(lastRemainingTeam);
		});
	}
	toCandidate(friend) {
		return this.repositories.candidateFactory.from(friend, this.assignment);
	}
	fulfillDemand({ volunteer, team }) {
		if (this.hasTeamAllDemandsFulfilled(team)) return this;
		const candidates = this._candidates.map((candidate) => candidate.json.id === volunteer ? candidate.demandAs(team) : candidate);
		const assignedCandidates = this.assignCandidateAccordingToRemainingDemands(candidates);
		return new AssignVolunteerFunnel(assignedCandidates, this.repositories, this.assignment);
	}
	hasTeamAllDemandsFulfilled(teamToAnalyse) {
		return this.remainingDemandsIfAssignThose(this._candidates).filter(({ demand, team }) => team === teamToAnalyse && demand > 0).length === 0;
	}
	revokeLastCandidate() {
		if (!this.canRevokeLastCandidate) return this;
		const candidates = this._candidates.slice(0, -1);
		return new AssignVolunteerFunnel(candidates, this.repositories, this.assignment);
	}
	async changeOtherCandidate(increment) {
		if (!this.canChangeLastCandidate) return Promise.resolve(this);
		const currentFriend = this._candidates.at(-1);
		if (!currentFriend) return Promise.resolve(this);
		const friendsAssignableOnLastDemand = this.friendsAssignableOnLastDemand;
		const currentFriendIndex = friendsAssignableOnLastDemand.findIndex(({ id }) => currentFriend.json.id === id);
		const totalAssignableFriends = friendsAssignableOnLastDemand.length;
		const nextIndex = (currentFriendIndex + increment) % totalAssignableFriends;
		const nextFriend = friendsAssignableOnLastDemand.at(nextIndex);
		if (!nextFriend) return Promise.resolve(this);
		return this.select(nextFriend);
	}
	async select(nextFriend) {
		const otherCandidatesThanTheLastOne = this.otherCandidatesThanTheLastOne;
		const asCandidate = await this.toCandidate(nextFriend);
		const candidates = [...otherCandidatesThanTheLastOne, asCandidate];
		const assignedCandidates = this.assignCandidateAccordingToRemainingDemands(candidates);
		return new AssignVolunteerFunnel(assignedCandidates, this.repositories, this.assignment);
	}
	async previousCandidate() {
		return this.changeOtherCandidate(-1);
	}
	nextCandidate() {
		return this.changeOtherCandidate(1);
	}
};
//#endregion
//#region src/break-periods/break-periods.ts
var BreakPeriods = class {
	breaks;
	constructor(breaks) {
		this.breaks = breaks;
	}
	async for({ volunteer, name, during: { start, duration } }) {
		const breaks = await this.breaks.of(volunteer);
		const endTimestamp = start.getTime() + duration.inMilliseconds;
		const breakPeriod = {
			name,
			start,
			end: new Date(endTimestamp)
		};
		const allBreaks = [...breaks, breakPeriod];
		return this.breaks.save(volunteer, allBreaks);
	}
	async of(volunteer) {
		return this.breaks.of(volunteer);
	}
	remove({ volunteer, period }) {
		return this.breaks.remove(volunteer, Period.init(period));
	}
};
//#endregion
export { AssignTaskToVolunteer, AssignVolunteerFunnel, AssignVolunteerToTask, AssignmentError, BreakPeriods, Candidate, CandidateFactory, ReadyToStart, TaskNotFoundError, WrongTeam, countAssigneesInTeam, extendOneOfTeams, isTeamMember, isWithDetails, retrieveImplicitTeams };

//# sourceMappingURL=index.mjs.map